module.exports = {
  BACKEND_SERVER: process.env.REACT_APP_PROD_BACKEND_SERVER,
  USER_SERVER: `${process.env.REACT_APP_PROD_BACKEND_SERVER}${process.env.REACT_APP_USER_SERVER}`,
  API_KEY: process.env.REACT_APP_API_KEY,
  S3_BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME,
  S3_URL: process.env.REACT_APP_S3_URL,
  S3_ENV: process.env.REACT_APP_S3_ENV_PROD,
  // Vimeo のシークレットはサーバー（.env）へ移行。動画アップロードは
  // POST /api/video/upload 経由で行うため、フロントには Vimeo 設定を持たない。
  AWS_ACCESS_KEY: process.env.REACT_APP_AWS_ACCESS_KEY,
  AWS_SECRET_KEY: process.env.REACT_APP_AWS_SECRET_KEY,
  AWS_REGION: process.env.REACT_APP_AWS_REGION,
  // トライアルグループコード
  TRIAL_GROUP_CODE: process.env.REACT_APP_TRIAL_GROUP_CODE,
  // 記事機能 利用ガイド（S3 ホスティングの HTML ガイド）の URL。全環境共通の固定値。
  // ※ 旧 REACT_APP_ARTICLE_GUIDE_SHORT_ID / _FILENAME（PublicDoc ダウンロード方式）は廃止（.env から削除可）
  ARTICLE_GUIDE_URL:
    'https://re-current-doc.s3.ap-northeast-1.amazonaws.com/system_guide/item/article-guide/index.html',
};
